import { Button, Box, TextField } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";

const SearchBox = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState("");
  const inputRef = useRef();

  useEffect(() => {
    const handleInput = () => {
      if (inputRef.current && !inputRef.current.value) {
        onSearch("");
        setSearchValue("");
      }
    };

    inputRef.current.addEventListener("input", handleInput);

    return () => {
      inputRef.current.removeEventListener("input", handleInput);
    };
  }, [onSearch]);

  const handleSearch = () => {
    onSearch(searchValue);
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Box display="flex" gap={1} alignItems="center" width="100%">
      <TextField
        fullWidth
        size="small"
        placeholder="Search by name"
        value={searchValue}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearch();
          }
        }}
        inputRef={inputRef}
      />

      <Button
        variant="contained"
        size="medium"
        onClick={handleSearch}
        sx={{
          backgroundColor: "#5a5c69", // Custom background color
          "&:hover": {
            backgroundColor: "#727482", // Custom hover background color
          },
        }}
      >
        Search
      </Button>
    </Box>
  );
};

export default SearchBox;
